<template>
  <div class="font-bold"><slot /></div>
</template>
